import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { version } from './environments/version';

if (environment.sentry) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    release: version.commit,
    environment: environment.env,
    ignoreErrors: [/The user canceled the OAuth flow/i],
    initialScope: {
      tags: {
        flavor: environment.flavor,
      },
    },
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category?.startsWith('ui.') && hint) {
        const { target } = hint['event'];

        if (target.ariaLabel) {
          breadcrumb.message = target.ariaLabel;
        }
      }

      return breadcrumb;
    },
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
